import React, { useContext } from 'react';
import { InsightsApi } from '@insights/insights-data-provider';

export const InsightsContext = React.createContext<InsightsApi>(new InsightsApi());

export const useInsights = () => useContext(InsightsContext);

type Props = {
  children: React.ReactNode;
};

export const InsightsProvider = ({ children }: Props) => {
  const insightsApi = useInsights();
  return <InsightsContext.Provider value={insightsApi}>{children}</InsightsContext.Provider>;
};

export const withInsights = (
  Component: React.FunctionComponent<any>
): React.FunctionComponent<{ children: React.ReactNode }> => (props: any) => (
  <InsightsContext.Consumer>
    {insightsApi => <Component {...props} insightsApi={insightsApi} />}
  </InsightsContext.Consumer>
);
